import { FileDown, FileSpreadsheet, Search, X } from "lucide-react";

export function SearchBar({ value, onChange, placeholder = "Rechercher...", testid = "search-input", count, total }) {
  return (
    <div className="mb-5">
      <div className="relative max-w-md">
        <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-[var(--tm-muted)] pointer-events-none" />
        <input
          type="text"
          className="tm-input pl-9 pr-9"
          placeholder={placeholder}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          data-testid={testid}
        />
        {value && (
          <button
            type="button"
            onClick={() => onChange("")}
            className="absolute right-3 top-1/2 -translate-y-1/2 text-[var(--tm-muted)] hover:text-[var(--tm-gold)]"
            data-testid={`${testid}-clear`}
          >
            <X size={15} />
          </button>
        )}
      </div>
      {value.trim() && typeof count === "number" && typeof total === "number" && (
        <p className="text-xs text-[var(--tm-muted)] mt-1.5" data-testid={`${testid}-count`}>
          {count} résultat{count > 1 ? "s" : ""} sur {total}
        </p>
      )}
    </div>
  );
}

export function PageHeader({ title, subtitle, children }) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-7">
      <div>
        <p className="text-xs uppercase tracking-[0.2em] text-[var(--tm-gold)] mb-1.5">TIRAMESSI</p>
        <h1 className="font-display text-3xl sm:text-4xl tracking-tight">{title}</h1>
        {subtitle && <p className="text-[var(--tm-muted)] text-sm mt-1.5">{subtitle}</p>}
      </div>
      <div className="flex flex-wrap items-center gap-2">{children}</div>
    </div>
  );
}

export function ExportButtons({ onPDF, onExcel }) {
  return (
    <>
      <button className="tm-btn-ghost tm-btn" onClick={onExcel} data-testid="export-excel-btn">
        <FileSpreadsheet size={16} /> Excel
      </button>
      <button className="tm-btn-ghost tm-btn" onClick={onPDF} data-testid="export-pdf-btn">
        <FileDown size={16} /> PDF
      </button>
    </>
  );
}

export function StatCard({ label, value, sub, icon: Icon, accent, testid }) {
  return (
    <div className="tm-card p-5 tm-fade" data-testid={testid}>
      <div className="flex items-start justify-between">
        <p className="text-xs uppercase tracking-wider text-[var(--tm-muted)]">{label}</p>
        {Icon && (
          <span className="w-9 h-9 rounded-lg flex items-center justify-center" style={{ background: "rgba(212,175,55,.12)" }}>
            <Icon size={17} style={{ color: accent || "var(--tm-gold)" }} />
          </span>
        )}
      </div>
      <p className="font-display text-3xl mt-3 tabular" style={{ color: accent || "var(--tm-beige)" }}>{value}</p>
      {sub && <p className="text-xs text-[var(--tm-muted)] mt-1">{sub}</p>}
    </div>
  );
}

export function Empty({ text }) {
  return <div className="text-center py-16 text-[var(--tm-muted)]">{text}</div>;
}

export function Loader() {
  return (
    <div className="flex justify-center py-20">
      <div className="w-8 h-8 rounded-full tm-spin" style={{ border: "3px solid #262626", borderTopColor: "var(--tm-gold)" }} />
    </div>
  );
}

const STATUTS = {
  en_attente: { label: "En attente", bg: "rgba(255,152,0,.15)", c: "#FF9800" },
  en_preparation: { label: "En préparation", bg: "rgba(212,175,55,.15)", c: "#D4AF37" },
  prete: { label: "Prête", bg: "rgba(76,175,80,.15)", c: "#4CAF50" },
  livree: { label: "Livrée", bg: "rgba(163,163,154,.15)", c: "#A3A39A" },
  annulee: { label: "Annulée", bg: "rgba(244,67,54,.15)", c: "#F44336" },
};

export function StatusBadge({ statut }) {
  const s = STATUTS[statut] || STATUTS.en_attente;
  return <span className="tm-badge" style={{ background: s.bg, color: s.c }}>{s.label}</span>;
}

export { STATUTS };
